// extracted by mini-css-extract-plugin
export default {"employeeCell":"EmployeeCell-EmployeeCell__employeeCell--b3YYC","notesTooltip":"EmployeeCell-EmployeeCell__notesTooltip--dlVcv"};